<dealer-display></dealer-display>
<div class="activate">
	<div class="banner-full-width top-banner">
		<div class="container">
			<div class="Rectangle1 background-image-entirescreen">
				<div class="row justify-content-start">
					<div class="col">
						<h1 class="desktop-heading">Need to activate <br /> your Dodo SIM?</h1>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="banner-full-width banner-A-B-test">
		<div class="Rectangle1 background-image-entirescreen-A-B-test">
			<div class="row justify-content-center">
				<div class="col">
					<h1 class="desktop-heading-A-B-test">Need to activate your<br /> Dodo mobile SIM?</h1>
				</div>
			</div>
		</div>
	</div>
	<div class="banner-full-width">
		<div class="container">
			<div class="img-display">
				<img src="../../assets/icons/sim-activate.svg" alt="">
			</div>
			<div class="Before-you-start">
				<span>Before you activate your mobile service</span>
				<!--<span class="sm-only">Keeping your number?</span> -->
			</div>
			<div class="keeping-your-number">
				<span>
					If you're transferring your existing number, please keep your old SIM in the phone until you've
					received an email confirming your Dodo SIM is ready to use.
				</span>
			</div>
		</div>
	</div>
	<div class="banner-full-width">
		<div class="container">
			<div class="row">
				<div class="col pl-4 pt-2 pb-2 pr-4">
					<div class="Its-easy-Grab-your">
						<form [formGroup]="_form" id="activateForm">

							<div class="sim-input-box">
								<p>
									Enter the SIM number found on the back of the SIM card.
								</p>
								<tc-masked-form-field 
								    class="sim-input-text"
								    controlName="simNumber" keyRestrictions="numeric-only"
									[label]="'SIM number'" [maxLength]="20" [mask]="_mask"
									[type]="'tel'" [replacementMap]="_replacementMap"
									data-test-id="activate_sim_simNumber"></tc-masked-form-field>
							</div>
						</form>
						<!--<div *ngIf="error" [innerHtml]="error" class="activate__error"></div> -->
						<div class="activate__action">
							<div class="continue">
								<p class="activate__popup" (click)="openDialog()"
									data-test-id="activate_sim_cannot-find-sim">
									I can't find my SIM number
								</p>
								<secondary-button class="action-btn" color="secondary" (clicked)="formSubmit()"
									[height]="50" [disabled]="_form.invalid || activateSimIsDisabled || busy"
									[busy]="busy" [theme]="buttonTheme" data-test-id="activate_sim_activate-btn">
									Activate Sim
								</secondary-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>